import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";

// Styled components for the step connector and step icon
const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#135fc2",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#135fc2",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: "#D2DFF1",
    borderRadius: 1,

    // // Dark mode override using global selector
    // [`[data-theme="dark"] &`]: {
    //   backgroundColor: "#000000 !important",
    // },
  },
  "&.MuiStepConnector-root": {
    left: "calc(-50% + 40px)",
    right: "calc(50% + 40px)",
  },
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    ownerState.active || ownerState.completed ? "#135fc2" : "#D2DFF1",
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  opacity: ownerState.active || ownerState.completed ? 1 : 0.5,
}));

// Function to display the step icon
function ColorlibStepIcon(props) {
  const { active, completed, icon } = props;

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }}>
      {icon}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

// Stepper component that accepts steps and activeStep as props
export default function CustomizedSteppers({ steps, activeStep, userDetails }) {
  return (
    <Stack sx={{ width: "100%" }} spacing={4}>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<ColorlibConnector />}
        sx={{
          "& .MuiStepLabel-label.Mui-active": {
            color: "#135fc2",
          },
          "& .MuiStepLabel-labelContainer": {
            color: userDetails === "dark" ? "#ffffff" : "#000000",
          },
          "& .MuiStepLabel-label.Mui-completed": {
            color: userDetails === "dark" ? "#ffffff" : "#000000",
            opacity: "0.5",
          },
        }}
      >
        {steps.map((step, index) => (
          <Step key={step.title}>
            <StepLabel
              StepIconComponent={() => (
                <ColorlibStepIcon
                  completed={activeStep > index}
                  active={activeStep === index}
                  icon={step.icon}
                />
              )}
            >
              {/* Display title and subtitle for each step */}
              <div>
                <strong>{step.title}</strong>
                <div>{step.subtitle}</div>
              </div>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
}

CustomizedSteppers.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string,
      icon: PropTypes.node.isRequired,
    })
  ).isRequired,
  activeStep: PropTypes.number.isRequired,
};
